export const fetchSwiper = () => import(/* webpackChunkName: "swiper" */ 'swiper');

export const fetchIMask = async () => import('imask' /* webpackChunkName: "imask" */).then((m) => m.default);
